export default "__VITE_ASSET__BxKemXko__"